import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';

const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.background.default,
  height: '100vh',
  overflow: 'hidden',
}));

const Content = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
}));

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <LayoutContainer>
      <Sidebar />
      <Content>{children}</Content>
    </LayoutContainer>
  );
};

export default Layout;
